export const MATCHING_TARGETS_TABS = {
  SUGGESTIONS: "suggestions",
  CATALOG: "catalog"
}
